import { PageWithLayout } from "@types";
import type { GetServerSideProps } from "next";
import { setContext } from "@utils/Cookies";
import { getLayout as getDefaultLayout } from "@layouts/default-layout";
import { festivalFetchData } from "@features/landing/helpers/festival-fallback";
import { getI18nPageProps } from "@utils/translates";
import LandingPage from "@features/landing/page";
import { setNotFoundResponse } from "lib/ssr/not-found";

const Landing: PageWithLayout<{ is404?: boolean }> = ({ is404 }) => {
  return <LandingPage is404={is404} />;
};

Landing.getLayout = (page, props) => {
  return getDefaultLayout(
    page,
    { ...props },
    {
      footerProps: {
        showAdsFooter: false,
        showOrganizationFooter: false,
        showAppFooter: false,
        showValuesFooter: false,
      },
      headerProps: {
        hideFestivalBanner: true,
      },
    }
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  setContext(ctx);
  const i18nProps = await getI18nPageProps(ctx, "landing");

  const { query, req, res } = ctx;
  const ssrActivated =
    String(req.headers?.["x-ssr-activate"]).toLowerCase() !== "false";
  if (!ssrActivated) {
    return { props: i18nProps };
  }

  try {
    const fallback = await festivalFetchData(query);
    return {
      props: {
        ...i18nProps,
        fallback,
      },
    };
  } catch (error: any) {
    if (error?.error?.code === 404) setNotFoundResponse(res);

    return {
      props: {
        ...i18nProps,
        is404: error?.error?.code === 404,
      },
    };
  }
};

export default Landing;
